import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createHttpContainer } from './di/container';
import { App } from './presentation/app/App';
import '@fontsource-variable/inter';
import './presentation/styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App container={createHttpContainer()} />
  </StrictMode>,
);
